
import Vue from "vue";
import loginService from "../../../services/loginService";
import msDataProvider from "../../../services/msDataProvider";
import XCardBasedForm from "../../../components/XCardBasedForm.vue";
import humanizeString from "humanize-string";
import uiService from "../../../services/uiService";
import errorService from "../../../services/errorService";
import { mdiArrowLeft } from "@mdi/js";
import {addAction} from "@/services/firebase/writeData";

export default Vue.extend({
  components: {
    XCardBasedForm,
  },
  props: ["buttonLabel", "useAnotherMethodText", "onReady"],
  data() {
    return {
      errorService,
      mdiArrowLeft,
      loading: false,
      error: "",
      message: "",
      isSystemError: false,
      showOptionMethod: false,
      prepareLoginResponse: null,
      data: {},
      mfaData: {},
      sheet: false,
    };
  },
  watch: {
    error() {
      this.$emit('errorChange', this.error);
    }
  },
  methods: {
    mfaTitle(mfa) {
      return humanizeString(mfa);
    },
    resetError() {
      this.error = '';
      this.isSystemError = '';
    },
    async logout() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("LAYOUT.DO_YOU_REALLY_WANT_TO_LOGOUT_THIS_APP"),
                title: this.$t("LAYOUT.LOGOUT"),
                cancel: this.$t("LAYOUT.CANCEL"),
                ok: this.$t("LAYOUT.LOGOUT"),
                iconOk: 'icon-logout-white24'
              },
              true
          )
      ) {
        uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("authenLogout", {});
            this.$router.push("/prepare").catch((e) => e);
          },
          self: this,
        });
        sessionStorage.removeItem('userId')
      }
    },
    changeMfa(mfa) {
      if (mfa === this.prepareLoginResponse.type) {
        this.$router.push({
          path: "prepare",
          query: {
            type: mfa,
            resend: true,
          },
        });
      } else {
        this.$router.push({
          path: "prepare",
          query: {
            type: mfa,
          },
        });
      }
    },
    onReadyToSubmit(mfaData) {
      if (this.loading) {
        return;
      }
      this.mfaData = mfaData;
      this.loading = true;
      this.submit();
    },
    async submit(callback?: any) {
      try {
        const baseRequest = {
          type: this.prepareLoginResponse.type,
          biometric_data: sessionStorage.getItem("biometricData") || "",
          user_agent: navigator.userAgent,
        };
        for (const k in this.mfaData) {
          baseRequest[k] = this.mfaData[k];
        }
        const response = await msDataProvider.executeCommand(
            "authenLogin",
            baseRequest
        );
        if (response.error_info.error_code) {
          this.error = response.error_info.message;
          this.loading = false;
          this.isSystemError = false;
          await addAction('submit_otp', response.error_info)
        } else {
          this.$router.push("prepare").catch((e) => e);
          this.loading = false;
          callback && callback();
          await addAction('submit_otp')
        }
      } catch (e) {
        this.error = e;
        this.loading = false;
        this.isSystemError = true;
        callback && callback(e, true);
      }
    },
  },
  created() {
    this.prepareLoginResponse = loginService.getPrepareLoginResponse();
    this.message = this.prepareLoginResponse.message;
    if (this.onReady) {
      this.onReady(this.prepareLoginResponse, this.onReadyToSubmit, () => {
        this.$refs.cardBasedForm.submit();
      });
    }
  },
});
